<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-xm(:title="$t('mantra')")
    .grid.is-widescreen-8.is-desktop-10
      .column
        p.u-text-lg {{$t('mantraDesc')}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-xm(:title="$t('sec1')" tag="h2")
    .grid.is-tablet-6
      .column.u-mb-sm(v-for="item,idx in $t('sec1Items')")
        p {{ item }}


  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec2')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec2Items')")
            h4 {{item.title}}
            p {{item.desc}}


  section.u-mt-md
    AppTitle.u-mb-mi(:title="$t('sec3')" tag="h2")

    .grid.is-desktop-4.is-tablet-6
      .column.u-mb-sm(v-for="item,idx in $t('sec3Items')")
        h4 {{item.name}}


  section.u-mt-md.u-mb-md
    AppLink(to="/contact" :title="$t('cta')" class="button-link is-large " v-html="$t('cta')")

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Social media meetup",
    "pageDesc":"Baianat social media meetup is an opportuintiy to get deeper insights on social media reality and how brands thrive in it.",
    "mantra":"Social media |meetup",
    "mantraDesc":"Social media has been a great way for brands to connect with their audience and be part of their daily life. During the meetup we will focus on new techniques for social ads, new art directions that could inspire your next visual content and how to use social channe;ls to drive more sales and build a brand fanbase.",
    "sec1":"Why we are holding this meetup?",
    "sec1Items":{
      "1":"We believe in social media powers in building and growing brands. And to help digital marketers better integrate these channels into their strategy and avoid vanity merticus, we are holding this meetup to spread awareness on the essence of social media and how to use for building deep relationships with audience and  be part of their lifestyle."
    },
    "sec2":"The meetup agenda",
    "sec2Items":{
      "1":{
        "title":"Social behavior",
        "desc":"Online users are in a hurry and it takes more effort than before to draw their attention. During the meetup we will have open discussions about the best techniques that worked with users and how it increased the conversion  over the sales funnel."
      },
      "2":{
        "title":"Influncer marketing ",
        "desc":"Know the latest in influencer marketing and how to integrate them into your social media strategy for brand outrea"
      },
      "3":{
        "title":"Social channels",
        "desc":"Every channel has its own target audience, advertising mechanisms, and style of visuals. We give you our best on insights on that and share the most successful campaigns we have optimized for these different channels."
      }
    },
    "sec3":"Meetup |speakers",
    "sec3Items":{
      "1":{
        "name":"Mostafa Wahba"
      },
      "2":{
        "name":"Ahmed Alaa"
      },
      "3":{
        "name":"Mohamed Ahmed"
      }
    },
    "cta":"Registration will <br> be open soon."
  },
  "ar": {
    "pageTitle":"ملتقى وسائل التواصل الاجتماعي",
    "pageDesc":"يعد ملتقى بيانات لوسائل التواصل الاجتماعي فرصة مناسبة من أجل الحصول على رؤى أعمق حول واقع وسائل التواصل الاجتماعي وكيفية ازدهار العلامة التجارية عليها.",
    "mantra":"ملتقى وسائل |التواصل الاجتماعي.",
    "mantraDesc":"تعتبر وسائل التواصل الاجتماعي وسيلة رائعة للعلامة التجارية للتواصل مع جمهورها وكذلك لتصبح جزءًا من حياتهم اليومية. أثناء الملتقى، سوف نركز على التقنيات الجديدة لإعلانات وسائل التواصل الاجتماعي، والاتجاهات الفنية الجديدة التي يمكن أن تلهم المحتوى البصرى، وكيفية استخدام القنوات المختلفة من أجل زيادة المبيعات وبناء قاعدة جماهيرية للعلامة التجارية.",
    "sec1":"لماذا نعقد هذا الملتقى؟",
    "sec1Items":{
      "1":"نؤمن بأهمية وسائل التواصل الاجتماعي في بناء ونمو  العلامات التجارية. لمساعدة المسوقين الرقميين على دمج هذه القنوات بشكل أفضل في استراتيجيتهم وتجنب  المقاييس المضللة، فإننا نعقد هذا الملتقى لنشر الوعي حول جوهر وسائل التواصل الاجتماعي وكيفية استخدامها لبناء علاقات عميقة مع الجمهور بحيث تكون العلامة التجارية جزءًا من أسلوب حياتهم."
    },
    "sec2":"أجندة الملتقى",
    "sec2Items":{
      "1":{
        "title":"سلوك القنوات الاجتماعية",
        "desc":"مستخدمو الانترنت دائمًأ في عجلة من أمرهم؛ لهذا نبذل المزيد من الجهد من أجل لفت انتباههم. أثناء الملتقى، سوف نجري مناقشات مفتوحة حول أفضل التقنيات التي لفتت انتباه المستخدمين وكيفية زيادة التحويل على مسار المبيعات."
      },
      "2":{
        "title":"التسويق من خلال المؤثرين ",
        "desc":"تعرف على أحدث ما في مجال التسويق من خلال المؤثرين وكيفية دمجهم في استراتيجية وسائل التواصل الاجتماعي الخاصة بك من أجل التواصل بعمق مع الجمهور المستهدف."
      },
      "3":{
        "title":"القنوات المختلفة",
        "desc":"كل قناة لها جمهورها، وآليات الإعلانات، وأسلوب المرئيات الخاص بها. نقدم لك أفضل ما لدينا حول مختلف الأفكار ونشارك أنجح الحملات التي قمنا بتحسينها لهذه القنوات المختلفة."
      }
    },
    "sec3":"متحدثو |الملتقى",
    "sec3Items":{
      "1":{
        "name":"مصطفي وهبة"
      },
      "2":{
        "name":"أحمد علاء"
      },
      "3":{
        "name":"محمد أحمد"
      }
    },
    "cta":"التسجيل سوف يكون <br> متاح قريبًا"
  }
}
</i18n>
